import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IStepTree, TError } from './types/step-tree-interface'

const StepTreeState = (state: RootState): IStepTree => state.stepTree

export const PriceFinal = createSelector(
    [StepTreeState],
    (state): number => state.Price,
)
export const UidFinal = createSelector(
    [StepTreeState],
    (state): string => state.Uid,
)
export const PaylinkFinal = createSelector(
    [StepTreeState],
    (state): string => state.Paylink,
)

export const Polis = createSelector(
    [StepTreeState],
    (state): string => state.Polis,
)

export const isLoading = createSelector(
    [StepTreeState],
    (state): boolean => state.isLoading,
)
export const Error = createSelector(
    [StepTreeState],
    (state): TError => state.error,
)
